const messages = {
  title: "Vavčerji",
  short_description:
    "Tu lahko najdete vaš seznam vavčerjev. Lahko jih delite s svojo stranko. Vavčerji so za enkratno uporabo.",
  table: {
    headers: {
      voucher: "Kode vavčerjev",
      company: "Podjetje",
      street: "Ulica",
      postcode: "Poštna številka",
      location: "Lokacija",
      solved_at: "Datum",
      points: "Število točk preko kode",
    },
  },
  exchange: {
    title: "Vnesite vašo kodo za pridobitev točk",
    pointsLabel: "Vnesite kodo tukaj:",
    result: "Število točk:",
  },
};

export default {
  messages,
};
